import { meshComponent } from './Mesh'
import { props, createGeometry } from '../geometries/CapsuleGeometry'

export default meshComponent('Capsule', props, createGeometry)
